import { useRef, useEffect, useState, useCallback, useMemo } from 'react';

function useSortState(args) {
  const stableCb = useRef(args?.onSort);
  useEffect(() => {
    stableCb.current = args?.onSort;
  }, [args?.onSort]);
  const [sortBy, setSortBy] = useState("date");
  const [direction, setDirection] = useState("desc");
  const onSort = useCallback(nextSort => {
    if (sortBy === nextSort) {
      setDirection(prev => prev === "asc" ? "desc" : "asc");
    } else {
      setSortBy(nextSort);
      setDirection("asc");
    }
    stableCb.current?.();
  }, [sortBy]);
  return useMemo(() => [{
    sortBy,
    direction
  }, onSort], [direction, onSort, sortBy]);
}
function sortComponentEntries(options, a, b) {
  let result = 0;
  if (!a && !b) {
    return 0;
  }
  if (!a) {
    return -1;
  }
  if (!b) {
    return 1;
  }
  switch (options.sortBy) {
    case "componentTitle":
      result = a.component.title.localeCompare(b.component.title, "da-DK", {
        numeric: true
      });
      break;
    case "productTitle":
      result = a.product?.title.localeCompare(b.product?.title ?? "", "da-DK", {
        numeric: true
      }) ?? -1;
      break;
    case "date":
      {
        result = (a.modifiedAt ?? b.createdAt).getTime() - (b.modifiedAt ?? b.createdAt).getTime();
        break;
      }
    case "studentName":
      {
        if ("student" in a && "student" in b) {
          result = a.student.name.localeCompare(b.student.name);
        }
        break;
      }
    case "studentTeam":
      {
        if ("student" in a && "student" in b) {
          result = a.student.team.localeCompare(b.student.team, "da-DK", {
            numeric: true
          });
        }
        break;
      }
  }
  return result * (options.direction === "asc" ? 1 : -1);
}

export { sortComponentEntries, useSortState };
//# sourceMappingURL=sort.js.map
